import { createActions, createReducer } from "reduxsauce"
import { omit, get } from "lodash"
import { Types as OptimizationTypes } from "modules/optimization/model"

export const { Types, Creators } = createActions({
  setTradeType: ["tradeType"],
  setOpenTradeId: ["id"],
  setTradeConstraint: ["ticker", "mic", "key", "constraintType", "originalPercentEquity", "options"],
  loadTradesConstraints: ["tradesConstraints"],
  resetSettings: [],
}, {
  prefix: "ompnt/modules/optimizationTrades",
})

const DEFAULT_STATE = {
  tradeType: "buy",
  openTradeId: null,
  constraints: {},
}

function handleSetTradeType(state, { tradeType }) {
  return { ...state, tradeType }
}

function handleSetOpenTradeId(state, { id }) {
  if (state.openTradeId === id) {
    id = null
  }

  return { ...state, openTradeId: id }
}

function handleSetTradeContraint(state, { ticker, mic, key, constraintType, originalPercentEquity, options }) {
  let constraints = state.constraints
  if (constraintType === null) {
    constraints = omit(constraints, key)
  } else {
    let min, max

    if (constraintType === "range") {
      min = get(options, "min", get(state.constraints, [key, "min"], "-0.5"))
      max = get(options, "max", get(state.constraints, [key, "max"], "0.5"))
    }

    constraints = { ...constraints, [key]: { ticker, mic, constraintType, originalPercentEquity, min, max } }
  }

  return { ...state, constraints }
}

function handleReset(state) {
  return { ...state, ...DEFAULT_STATE }
}

function handleLoadTradesConstraints(state, { tradesConstraints }) {
  return { ...state, ...DEFAULT_STATE, constraints: tradesConstraints }
}

export default createReducer(DEFAULT_STATE, {
  [Types.SET_TRADE_TYPE]: handleSetTradeType,
  [Types.SET_OPEN_TRADE_ID]: handleSetOpenTradeId,
  [Types.SET_TRADE_CONSTRAINT]: handleSetTradeContraint,
  [Types.LOAD_TRADES_CONSTRAINTS]: handleLoadTradesConstraints,
  [Types.RESET_SETTINGS]: handleReset,
  [OptimizationTypes.RESET_SETTINGS]: handleReset,
})
